import PropTypes from 'prop-types';

const FormRowSelect = ({
  name,
  labelText,
  list,
  handleChange,
  value,
  defaultValue, 
}) => {
  return (
    <div className='form-row'>
      <label htmlFor={name} className='form-label'>
        {labelText || name}
      </label>
      <select
        name={name}
        id={name}
        onChange={handleChange}
        className='form-select'
        value={value}
        defaultValue={defaultValue} 
      >
        {list.map((itemValue) => {
          return (
            <option key={itemValue} value={itemValue}>
              {itemValue}
            </option>
          );
        })}
      </select>
    </div>
  );
};

FormRowSelect.propTypes = {
  name: PropTypes.string.isRequired,
  labelText: PropTypes.string,
  list: PropTypes.array.isRequired,
  handleChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  defaultValue : PropTypes.string,
};

export default FormRowSelect;
